<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Solicitação de Compras/Cotação
  </div>
  <!--  @if (checkPermission('criar')) {-->
  <!--  <div class="mr-8">-->
  <!--    <button mat-raised-button class="btn-add" (click)="newPriceQuote()">-->
  <!--      Nova Cotação-->
  <!--    </button>-->
  <!--  </div>-->
  <!--  }-->
</div>

<mat-tab-group (selectedIndexChange)="onTabChange($event)">
  <mat-tab label="Solicitações">
    <div>
      <div class="mt-4">
        <!--    @if (checkPermission('pesquisar-paginado')) {-->
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Pesquisa </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <!--            <form-search-proposal-client-->
              <!--              [search]="inputSearch"-->
              <!--              (responseSearch)="search($event)"-->
              <!--            />-->
              <form-search-quote-request-tg-new
                [search]="inputSearch"
                (responseSearch)="search($event)"
              />
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <!--    }-->

        <div class="mt-6">
          @if (!loading) {
            <div>
              <!--          <table-list-simple-->
              <table-list-tariff
                [dataSource]="itemsList"
                [columns]="columns"
                (viewItinerariesItem)="viewItinerariesEvent($event)"
                (selectItem)="selectItemEvent($event)"
              />
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          <div [hidden]="itemsList.length == 0">
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="pageChanged($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Cotações Recusadas">
    <div>
      <div class="mt-4">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Pesquisa </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <form-search-refused-quotes
                (responseSearch)="searchRefused($event)"
              />
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="flex justify-end mt-4">
          <button
            mat-raised-button
            class="btn-add"
            [disabled]="exportingRefused"
            (click)="exportRefusedExcel()"
          >
            @if (exportingRefused) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Exportar Excel
            }
          </button>
        </div>

        <div class="mt-6">
          @if (!loadingRefused) {
            <div>
              <table-list-tariff
                [dataSource]="itemsListRefused"
                [columns]="columnsRefused"
              />
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          <div [hidden]="itemsListRefused.length == 0">
            <mat-paginator
              [length]="numberRowsRefused"
              [pageSize]="rowsRefused"
              [pageIndex]="pageRefused - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="pageChangedRefused($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="SLA">
    <div>
      <div class="mt-4">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Pesquisa </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <form-search-compras-historico
                (responseSearch)="searchSla($event)"
              />
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="flex justify-end mt-4">
          <button
            mat-raised-button
            class="btn-add"
            [disabled]="exportingSla"
            (click)="exportSlaExcel()"
          >
            @if (exportingSla) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Exportar Excel
            }
          </button>
        </div>

        <!-- fora do @if de loading: o card só muda quando o filtro muda, não a cada página -->
        <div class="mt-4 flex">
          <div
            class="rounded-lg border border-blue-200 bg-blue-50 p-3 flex flex-col"
          >
            <span class="text-xs text-gray-500 uppercase">
              Tempo médio de resposta do Compras
            </span>
            @if (loadingResumoSla) {
              <mat-spinner diameter="22" class="my-1"></mat-spinner>
            } @else {
              <span class="text-2xl font-bold text-blue-600">
                {{ tempoMedioSla ?? '—' }}
              </span>
            }
            <span class="text-xs text-gray-500">
              @if (tempoMedioSla) {
                média de {{ rodadasConsideradasSla }} ida(s) respondida(s) ·
                horário útil, seg. a sex., 09:00 às 18:00
              } @else {
                nenhuma ida respondida no filtro atual
              }
            </span>
          </div>
        </div>

        <div class="mt-6">
          @if (!loadingSla) {
            <div>
              <table-list-tariff
                [dataSource]="itemsListSla"
                [columns]="columnsSla"
                (selectItem)="viewSlaItem($event)"
              />
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
          <div [hidden]="itemsListSla.length == 0">
            <mat-paginator
              [length]="numberRowsSla"
              [pageSize]="rowsSla"
              [pageIndex]="pageSla - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="pageChangedSla($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
